import { createStore, Store, useStore as baseUseStore } from 'vuex';
import login, { LoginStoreState } from './modules/login';
import group, { State as GroupState } from './modules/group';
import user, { State as UserState } from './modules/user';
import chat from './modules/chat';
import { TChatStoreState } from './modules/chat/state';
import { InjectionKey } from 'vue';
import { CommonConfigManager, ICommonConfigData } from '_c/business/manager/common-config';

export interface RootState {
  config: ICommonConfigData;
}

export const key: InjectionKey<Store<RootState>> = Symbol();

export interface AllModuleState extends RootState {
  login: LoginStoreState;
  group: GroupState;
  user: UserState;
  chat: TChatStoreState;
}

const store = createStore<RootState>({
  state: () => ({
    config: CommonConfigManager.getInstance().config,
  }),
  mutations: {
    setConfig(state, config: ICommonConfigData) {
      state.config = config;
    },
  },
  actions: {
  },
  modules: {
    login,
    group,
    user,
    chat,
  },
});

export function useStore<T = AllModuleState>(): Store<T> {
  const baseStore = baseUseStore<T>(key);
  return baseStore ? baseStore : (store as unknown) as Store<T>;
}

export default store;
